
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/identity-security-posture",
      function () {
        return require("private-next-pages/solutions/identity-security-posture.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/identity-security-posture"])
      });
    }
  